/*
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-06-19 10:24:08
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-07-04 10:21:21
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\config\store-cuser.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineStore } from 'pinia';
import { logout } from '@/data/ApiUser';
import { postPhoneLogin, postUserInfo } from '@/data/api-cuser';
import { getEUserInfo } from '@/data/ApiUser';
// import storeMenu from './storeMenu';

import { getUserInfo } from '@/data/ApiUser';

import createUserStore from 'ai-assistant-lib/src/store/create-user-store';

const { state, getters, actions } = createUserStore({
  loginApi: postPhoneLogin,
  userInfoApi: getUserInfo, //postUserInfo,
  logoutApi: logout,
});

export default defineStore('cuser', {
  state() {
    return {
      ...state(),
      // loginType: 6,
      loginType: 4,
      // 模型信息，用于场景切换
      modelInfo: {},
      eUserInfo: {},
    };
  },
  getters: {
    ...getters,
    userName() {
      return this.info.userName || (this.info.phone ? this.info.phone : '');
    },
  },
  actions: {
    ...actions,

    afterReset() {
      this.eUserInfo = {};
      this.modelInfo = {};
    },

    changeModelInfo(obj) {
      this.modelInfo = { ...this.modelInfo, ...obj };
    },
    async afterGetUserInfo() {
      this.eUserInfo = await getEUserInfo({ phid: this.info.phid });
      this.eUserInfo.defaultConfigId = this.info.defaultConfigId;
      this.hasEName = !!this.eUserInfo.ename; // 企业名用于知识库分组
    },
  },
});
